/**
 * ClientInviteAcceptPage — WL-K5a Mandanten-Sicht: „Kanzlei-Zugang".
 *
 * Zielseite des Mail-Links (`/register?clientInvite=<token>` → nach Registrierung/
 * Login hierher, `/dashboard/konto/kanzlei-zugang`). Hostet ausschließlich das
 * {@link ClientInviteAcceptPanel}, das sich selbst gated: liegt kein Token vor (oder
 * ist kein User eingeloggt), rendert es nichts und es bleibt ein neutraler Hinweis.
 *
 * @module ClientInviteAcceptPage
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconHandshake } from '../icons';
import { useAuth } from '../context/AuthContext';
import { getClientInviteToken } from '../utils/clientInviteToken';
import ClientInviteAcceptPanel from '../components/tenant/ClientInviteAcceptPanel';

const ClientInviteAcceptPage: React.FC = () => {
  const { t } = useTranslation('common');
  const { pendingClientInvites } = useAuth();

  // Ein Token liegt vor, wenn der Context-Slot ihn führt ODER localStorage ihn hält
  // (der Slot wird beim Login gefüllt; localStorage deckt den Direkt-Aufruf ab).
  const hasToken = pendingClientInvites.length > 0 || !!getClientInviteToken();

  return (
    <div className="min-h-screen bg-surface p-4 md:p-6">
      <div className="max-w-3xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-primary flex items-center gap-3">
            <IconHandshake size={20} className="text-accent-ink" />
            {t('clientInvite.mandantPageTitle')}
          </h1>
          <p className="text-muted text-sm mt-1">{t('clientInvite.mandantPageSubtitle')}</p>
        </div>

        <ClientInviteAcceptPanel />

        {!hasToken && (
          <p className="rounded-lg bg-surface-raised p-4 text-sm text-muted">
            {t('clientInvite.noInvite')}
          </p>
        )}
      </div>
    </div>
  );
};

export default ClientInviteAcceptPage;
